module.exports = __webpack_public_path__ + "static/tlo_wenecja-fb63439a44c525eb2e62ee773ad69cca.png";